import { ReturnTaskReadable } from '@crm/api'
import { TaskForm } from '@crm/components'
import { useLocales } from '@shared/locales'
import { Modal } from 'antd'

import { ModalProps } from 'antd/lib'

const formName = 'add-edit-task-form'

type Props = {
  task?: ReturnTaskReadable | null
  onCancel: () => void
} & ModalProps

export const AddEditTask = ({ task, onCancel, ...props }: Props) => {
  const { t } = useLocales()

  return (
    <Modal
      width={800}
      maskClosable={false}
      title={t('lead.task')}
      cancelText={t('buttons.cancel')}
      okText={t('buttons.save')}
      destroyOnHidden
      okButtonProps={{
        htmlType: 'submit',
        form: formName
      }}
      onCancel={onCancel}
      {...props}
    >
      <TaskForm id={task?.id} formName={formName} onCancel={onCancel} />
    </Modal>
  )
}
